import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './eventoForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';

import { setModoTela, initForm, salvar, excluir, getLista } from './eventoActions';
import ContentCardFooter from '../common/template/contentCardFooter';
import Background from '../common/template/background';
import DateFormat from '../common/dateFormat/DateFormat';
import Calendario from '../common/calendario/calendario';
import { getLista as getListaTexto } from '../texto/textoActions';
import TextoInput from '../texto/textoInput';

class Evento extends Component {

	state = {
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaTexto();
    }

    render() {

        return (
			<>
				<div 
					style={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'center',
						flexWrap: 'wrap',
						backgroundColor: '#0F2748',
						width: '100%',
						padding: 16,
						color: '#ffffff'
					}}>
					<h2 style={{ fontSize: 'clamp(0.8rem, 2.5vw, 1.5rem)', margin: 0, padding: 0 }}>{this.props.eventoTitulo}</h2>
					
					<TextoInput chave='eventoTitulo' />
				</div>

				<Background
					backgroundPosition={'center'}
					gradientStart='#ffffff'
					gradientEnd='#ffffff'>
					<Content>
						<Aguardando aguardando={this.props.aguardando} />

						{this.props.modoTela == 'cadastro' ? (
							<Form onSubmit={this.props.salvar} />
						) : null}
						{this.props.modoTela == 'visualizacao' ? (
							<Form visualizacao onSubmit={this.props.salvar} />
						) : null}
						{this.props.modoTela == 'exclusao' ? (
							<Form excluir onSubmit={this.props.excluir} />
						) : null}
						{this.props.modoTela == 'lista' ? this.lista() : null}
					</Content>
				</Background>
			</>
        )
    }

	lista() {

		let lista = this.props.lista;

		return (
			<Row alignCenter>
				{this.props.sessao.administrador &&
				<Grid cols='12 6 4 3'>
					<Button
						text='Adicionar'
						type={'primary'}
						icon={'fa fa-plus'}
						event={() => {
							this.props.setModoTela('cadastro', {});
							this.props.initForm({});
						}} />
				</Grid>}

				<Grid cols='12 12 12 10'>
					<Calendario
						atualizarLista={data => this.props.getLista()}
						dados={lista.map(item => {

							return {
								id: item.id,
								data: item.data_evento,
								horas: null,
								titulo: ''
									+ `${item.nome}\n`
									+ `Local: ${item.endereco}\n`
									+ `Horário: ${item.horario}\n`
									+ item.descricao,
								descricao:
									<div>
									</div>,
								evento: () => {
									window.open(item.link, '_blank');
								},
								id_grupo: 1,
								diaTodo: false,
								corFundo: 'rgb(37, 67, 123)',
								corFonte: '#ffffff'
							}
						})}
						grupos={[{ id: 1, nome: '' }]}
					/>
				</Grid>
			</Row>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.evento.modoTela,
	aguardando: state.evento.aguardando,
	lista: state.evento.lista,
	eventoTitulo: state.texto.lista.filter(item => item.chave == 'eventoTitulo').map(item => item.valor)[0]
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista,
	getListaTexto
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Evento);
